import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  FlixxBalance,
  SearchBar,
  Button,
  Logo,
  Menu,
  NavRoutes,
  LangSelector,
  Text,
  Div,
  Avatar
} from 'ui'
import { Magnifier, Burger } from 'icons'
import useResponsive from 'utils/hooks/useResponsive'
import {
  useFlags,
  useLocation,
  useSession
} from 'hooks'
import {
  BurgerBtn,
  Container,
  Nav,
} from './styles'
import { useModal } from 'hooks';


const Header = () => {
  const { t } = useTranslation()
  const { isTab, isMobile } = useResponsive()
  const { isCommunitySectionEnabled } = useFlags()

  const { Modal } = useModal('welcome')
  const [isDarken, setIsDarken] = useState(false)
  const [isOpenSideMenu, setIsOpenSideMenu] = useState(false)

  const { isLoggedIn, user } = useSession();

  const login = () => Modal.open()

  const { isCreators, isSearch } = useLocation()

  useEffect(() => {
    const scroll = () => {
      const seventyFivePercent = window.innerHeight * 0.75
      if (window.scrollY > seventyFivePercent) setIsDarken(true)
      else setIsDarken(false)
    }

    window.addEventListener('scroll', scroll)
    return () => window.removeEventListener('scroll', scroll)
  }, [])


  return (
    <Container $isCreators={isCreators} isDarken={isDarken}>
      <Div
        display='flex'
        alignItems='center'
        gap={16}
        padding='10px 0'
      >
        <Nav>
          <Logo
            theme={isCreators ? 'light' : 'dark'}
            addCreators={isCreators}
            to={isCreators ? '/creators' : '/'}
          />

          {!isCreators && isCommunitySectionEnabled && (
            <NavRoutes />
          )}
        </Nav>

        {!isCreators && (
          isSearch
            ? !isTab && <SearchBar />
            : <Button size={isMobile ? 'small' : 'medium'} variant='icon' to='/search'><Magnifier /></Button>
        )}

        {isLoggedIn ? (
          <>
            <FlixxBalance />

            {!isCreators && (
              <BurgerBtn
                onClick={() => setIsOpenSideMenu(true)}
                variant='icon'
                size={isMobile ? 'small' : 'medium'}
              >
                <Burger />
                {/* <Avatar src={user.profile.avatar} /> */}
              </BurgerBtn>
            )}

            <Menu
              isOpen={isOpenSideMenu}
              onClose={() => setIsOpenSideMenu(false)}
            />
          </>
        ) : (
          <>
            {!isLoggedIn && <LangSelector />}

            <Div minWidth='max-content'>
              <Button onClick={login}>
                <Text color='headline' >
                  {t("enter")}
                </Text>
              </Button>
            </Div>
          </>
        )}
      </Div>

      {isTab && isSearch && <SearchBar />}
    </Container>
  )
}

export default Header